export const CopyrightDisplay = () => {
  return (
    <div
      className="p-2 pb-4 text-center w-100"
      style={{ position: "absolute", bottom: 0 }}
    >
      Copyright © {new Date().getFullYear()} Diligent Delivery Systems.®
      <br />
      All content, trade names and/or trade dress, trademarks, associated
      imagery are trademarks and/or copyright material of their respective
      owners. All rights reserved.
    </div>
  );
};
